import { makeAutoObservable, runInAction } from "mobx";
import agent from "../api/agent";
import { store } from "./store";
import { Pagination, PagingParams } from "../models/pagination";
import {
  IBrandData,
  IProductCategory,
  ProductCategory,
} from "../models/product";
import { toast } from "react-toastify";
import { IImalURl, ITicketItem, TicketForm } from "../models/tickets";
import {
  IReturnLocation,
  IReturnLocationForm,
  IShippingLocationPriceForm,
  RegionForm,
  RegionPriceForm,
  ReturnLocationForm,
  ShippingLocationPriceForm,
  ShippingPriceForm,
  ShippingPriceStatus,
  StateForm,
  StatePriceForm,
} from "../models/shipping";
import { regionOptions, stateOptions } from "../common/options/categoryOptions";
import { router } from "../router/Routes";

export default class ShippingStore {
  loading = false;
  loadingInitial = "";
  guidStatus = "";
  pagination: Pagination | null = null;
  pagingParams = new PagingParams();
  vendorReturnLocationList: IReturnLocation[] = [];
  stateList: StateForm[] = [];
  regionList: RegionForm[] = [];
  initialValues: IShippingLocationPriceForm | null = null;
  currentReturnLocation: IReturnLocation | null = null;

  constructor() {
    makeAutoObservable(this);
  }

  setLoading = (x: boolean) => {
    this.loading = x;
  };
  setGuidStatus = (x: string) => {
    this.guidStatus = x;
  };
  setLoadingInitial = (x: string) => {
    this.loadingInitial = x;
  };
  fetchReturnLocationAsync = async (id: string) => {
    this.guidStatus = "loading";
    try {
      const response = await agent.Shipping.getVendorReturnLocation(id);
      if (response.isSuccessful)
        runInAction(() => {
          this.currentReturnLocation = response.data;
        });
      else {
        toast.info(response.responseMessage);
        router.navigate("/vendor/shipping/returnlocationlist");
      }
      // this.guidStatus = "";
      return response;
    } catch (error) {
      this.guidStatus = "";
      var error1 = "Error fetching data";
      throw error1;
    }
  };
  getVendorReturnLocations = async () => {
    this.loadingInitial = "loading";
    try {
      const response = await agent.Shipping.getVendorReturnLocations();
      if (response.isSuccessful) {
        if (response.data !== null) {
          runInAction(() => {
            this.vendorReturnLocationList = response.data;
          });
        } else
          runInAction(() => {
            this.vendorReturnLocationList = [];
          });
      } else toast.info(response.responseMessage);
      this.loadingInitial = "";
      return response;
    } catch (error) {
      this.loadingInitial = "";
      var error1 = "Error fetching data";
      throw error1;
    }
  };

  getVendorShippingPriceLocations = async () => {
    this.loadingInitial = "loading";
    try {
      const response = await agent.Shipping.getVendorShippingPriceLocations();
      if (response.isSuccessful)
        runInAction(() => {
          this.stateList = stateOptions.map((state) => {
            const newState = new StateForm();
            newState.state = state.value;
            newState.stateId = state.value;
            return newState;
          });
          this.regionList = regionOptions.map((region) => {
            const newRegion = new RegionForm();
            newRegion.regionId = region.value;
            newRegion.region = region.value;
            return newRegion;
          });
          const newInitialValues = new ShippingLocationPriceForm();

          // const newUserShippingPriceForm = new ShippingPriceForm();
          if (response.data === null) {
            this.regionList.map((region, index) => {
              const newShippingPriceForm = new ShippingPriceForm();
              newShippingPriceForm.region = region.region;
              newShippingPriceForm.status = ShippingPriceStatus.false;
              newInitialValues.shippingPriceList.push(newShippingPriceForm);
            });
            this.stateList.map((state, index) => {
              const newShippingPriceForm = new ShippingPriceForm();
              newShippingPriceForm.state = state.state;
              newShippingPriceForm.status = ShippingPriceStatus.false;
              newInitialValues.shippingPriceList.push(newShippingPriceForm);
            });
          } else {
            newInitialValues.shippingPriceList = response.data.map(
              (data: {
                vendorShippingPriceId: string;
                fiveKgPrice: number;
                tenKgPrice: number;
                twentyFiveKgPrice: number;
                aboveKgPrice: number;
                state: string;
                region: string;
                status: any;
              }) => {
                const newShippingPriceForm = new ShippingPriceForm();
                newShippingPriceForm.shippingPriceId =
                  data.vendorShippingPriceId;
                newShippingPriceForm.fiveKgPrice = data.fiveKgPrice;
                newShippingPriceForm.tenKgPrice = data.tenKgPrice;
                newShippingPriceForm.twentyFiveKgPrice = data.twentyFiveKgPrice;
                newShippingPriceForm.aboveKgPrice = data.aboveKgPrice;
                newShippingPriceForm.state = data.state;
                newShippingPriceForm.region = data.region;
                newShippingPriceForm.status = data.status
                  ? ShippingPriceStatus.true
                  : ShippingPriceStatus.false;
                if (data.region && data.status) {
                  const newRegion = new RegionForm();
                  newRegion.regionId = data.region;
                  newRegion.region = data.region;
                  newInitialValues.regionList.push(newRegion);
                }
                if (data.state && data.status) {
                  const newState = new StateForm();
                  newState.stateId = data.state;
                  newState.state = data.state;
                  newInitialValues.stateList.push(newState);
                }
                return newShippingPriceForm;
              }
            );
          }

          this.regionList.map((region) => {
            if (
              newInitialValues.shippingPriceList.findIndex(
                (x) => x.region === region.region
              ) === -1
            ) {
              const newShippingPriceForm = new ShippingPriceForm();
              newShippingPriceForm.region = region.region;
              newShippingPriceForm.status = ShippingPriceStatus.false;
              newInitialValues.shippingPriceList.push(newShippingPriceForm);
            }
          });
          this.stateList.map((state, index) => {
            if (
              newInitialValues.shippingPriceList.findIndex(
                (x) => x.state === state.state
              ) === -1
            ) {
              const newShippingPriceForm = new ShippingPriceForm();
              newShippingPriceForm.state = state.state;
              newShippingPriceForm.status = ShippingPriceStatus.false;
              newInitialValues.shippingPriceList.push(newShippingPriceForm);
            }
          });

          this.initialValues = newInitialValues;
        });
      // else toast.info(response.responseMessage);

      this.loadingInitial = "";
    } catch (error) {
      this.loadingInitial = "";
      var error1 = "Error fetching data";
      throw error1;
    }
  };
  addStatePriceLocations = async (creds: ShippingPriceForm[]) => {
    this.loadingInitial = "loading";
    try {
      const response = await agent.Shipping.createShippingStatePriceList(creds);
      if (response.isSuccessful) {
        runInAction(() => (this.loadingInitial = ""));
        return response;
      } else
        runInAction(() => {
          this.loadingInitial = "";
          toast.info(response.responseMessage);
        });
    } catch (error) {
      this.loadingInitial = "";
      throw error;
    }
  };

  addRegionPriceLocations = async (creds: ShippingPriceForm[]) => {
    this.loadingInitial = "loading";
    try {
      const response = await agent.Shipping.createShippingRegionPriceList(
        creds
      );
      if (response.isSuccessful) {
        runInAction(() => (this.loadingInitial = ""));
        return response;
      } else
        runInAction(() => {
          this.loadingInitial = "";
          toast.info(response.responseMessage);
        });
    } catch (error) {
      this.loadingInitial = "";
      throw error;
    }
  };

  addReturnLocations = async (creds: IReturnLocation[]) => {
    this.loadingInitial = "loading";
    try {
      const response = await agent.Shipping.createReturnLocations(creds);
      if (response.isSuccessful) {
        runInAction(() => (this.loadingInitial = ""));
        return response;
      } else
        runInAction(() => {
          this.loadingInitial = "";
          toast.info(response.responseMessage);
        });
    } catch (error) {
      this.loadingInitial = "";
      throw error;
    }
  };
  updateReturnLocation = async (creds: IReturnLocation) => {
    this.loadingInitial = "loading";
    try {
      const response = await agent.Shipping.updateReturnLocation(creds);
      if (response.isSuccessful) {
        runInAction(() => (this.loadingInitial = ""));
        return response;
      } else
        runInAction(() => {
          this.loadingInitial = "";
          toast.info(response.responseMessage);
        });
    } catch (error) {
      this.loadingInitial = "";
      throw error;
    }
  };

  deleteReturnLocation = async (creds: string) => {
    this.loading = true;
    try {
      const response = await agent.Shipping.removeReturnLocation(creds);
      if (response.isSuccessful) {
        runInAction(() => {
          this.vendorReturnLocationList = this.vendorReturnLocationList.filter(
            (item) => {
              return item.returnProductLocationId !== creds;
            }
          );

          this.loading = false;
        });
        toast.info(response.responseMessage);
      } else
        runInAction(() => {
          this.loading = false;
          toast.info(response.responseMessage);
          // return response;
        });

      return response;
    } catch (error) {
      this.loading = false;
      throw error;
    }
  };
}
